import { Big } from "big.js";

const ZERO_STRING = "0";
const BASE = 10;

type ValueType = string | number | Big;

export const BigNumber = (value: ValueType | undefined | null) => {
  try {
    return Big(value || ZERO_STRING);
  } catch (error) {
    console.warn(`Error: ${error} \n\n while working with this value ${value} of such a type ${typeof value} `);
    return Big(ZERO_STRING);
  }
};

export const getRandomInt = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const removeTrailingZeros = (amount: string) => {
  if (amount.includes(".") || amount.includes(",")) {
    return amount.replace(/\.?0*$/, "");
  }
  return amount;
};

export const parseTokenAmount = (value: ValueType, decimals: number) =>
  BigNumber(value)
    .mul(BASE ** decimals)
    .toFixed(0);

export const formatTokenAmount = (value: string | number | Big, decimals = 18, precision?: number): string =>
  BigNumber(value).div(BigNumber(BASE).pow(decimals)).toFixed(precision);

const MIN_AMOUNT = "0.00001";

export const displayAmount = (amount: string, decimals?: number, precision = 5): string => {
  const formateAmount = formatTokenAmount(amount, decimals || 0);
  const amountBig = BigNumber(formateAmount);
  if (amountBig.eq(ZERO_STRING)) return ZERO_STRING;
  if (amountBig.lte(MIN_AMOUNT)) return `>${MIN_AMOUNT}`;
  return removeTrailingZeros(amountBig.toFixed(precision));
};

export function formatMonetaryAmount(value: number | string): string {
  try {
    const bigNumber = Big(value);
    if (bigNumber.lt(1_000)) {
      return value.toString();
    }

    const suffixes = [
      { value: 1_000_000_000_000, symbol: "T" },
      { value: 1_000_000_000, symbol: "B" },
      { value: 1_000_000, symbol: "M" },
      { value: 1_000, symbol: "k" },
    ];

    for (const suffix of suffixes) {
      if (bigNumber.gte(suffix.value)) {
        const abbreviated = bigNumber.div(suffix.value).toFixed(1);
        return `${parseFloat(abbreviated)}${suffix.symbol}`;
      }
    }
  } catch (e) {
    return "0";
  }
  return "0";
}
